import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Estado compartido del módulo de contabilidad: el emisor y ejercicio
 * seleccionados se mantienen al navegar entre las pestañas (Plan, Diario,
 * Mayor, Informes, 303, Config). Persistido en localStorage.
 */
interface AccountingState {
  emisorId: number | null;
  ejercicio: number;
  setEmisorId: (id: number | null) => void;
  setEjercicio: (year: number) => void;
}

export const useAccountingStore = create<AccountingState>()(
  persist(
    (set) => ({
      emisorId: null,
      ejercicio: new Date().getFullYear(),
      setEmisorId: (id) => set({ emisorId: id }),
      setEjercicio: (year) => set({ ejercicio: year }),
    }),
    { name: "inpronexus.accounting.ctx" },
  ),
);
